import React, { useState, useEffect } from 'react';
import config from './../../../config';
import { getLanguage } from '../../../utils/i18n';

function PageHeader(props) {
  const lang = getLanguage();
  const [html, setHtml] = useState('');

  useEffect(() => {
    const url =
      props.context === 'sdg'
        ? `./header_footer_SDG/header-sdg-${lang}.html`
        : `./header_footer_CEPALSTAT/header-${lang}.html`;

    fetch(url)
      .then(res => res.text())
      .then(string => {
        string = string.replaceAll('%PUBLIC_URL%', config.PUBLIC_URL);
        setHtml(string);
      });
  }, [lang, props.context]);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: html }}></div>
    </>
  );
}

export default PageHeader;
